// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"76":"496b1a7b","385":"a47908aa","611":"37ffd2d5","747":"fc06c6a2"}[chunkId] + ".js";
};